export default __webpack_public_path__ + "atomic/_patterns/02-molecules/exposed-filter-search/_exposed-filter-search.twig";